import { Panel } from "reactflow";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
import useFlowVersions from "hooks/useFlowVersions";

const ModeControl = () => {
  const { allowEditWorkflow } = useAllowEditWorkflow();
  const { changeMode } = useFlowVersions(null, false);

  const handleSwitchEditMode = () => {
    changeMode();
  };

  return (
    <Panel position="top-center" style={{ marginTop: "20px" }}>
      <SoftBox px={1} backgroundColor="#7443ff" borderRadius="8px">
        <SoftTypography variant="caption" color="white" fontWeight="light">
          Currently viewing in read-only mode.{" "}
          {allowEditWorkflow ? (
            <span
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={handleSwitchEditMode}
            >
              Switch to edit-mode.
            </span>
          ) : null}
        </SoftTypography>
      </SoftBox>
    </Panel>
  );
};

export default ModeControl;
